import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FormSpinner from '../../common/utility/FormSpinner';
import FormMessage from '../../common/utility/FormMessage';
import * as resetPasswordFormActions from '../../../store/actions/reset-password-actions';
import * as signInFormActions from '../../../store/actions/sign-in-form-actions';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import { formConstants } from '../../utils/constants/form-constants';
import { isEmpty } from '../../utils/obj-utils';
import initialState from '../helpers/form-helpers/initial-state';
import FormBuilder from '../helpers/form-builder';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import {
    getParameterByName,
    reloadToBasePage
} from '../../../../../general/js/utils';

class ResetPasswordForm extends Component {
    constructor(props) {
        super(props);

        this.state = initialState.resetPasswordFormState;

        this.displayResetPasswordForm = this.displayResetPasswordForm.bind(this);
        this.displayForm = this.displayForm.bind(this);
        this.loadResetPasswordForm = this.loadResetPasswordForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.signInUser = this.signInUser.bind(this);
        this.handleValidationResult = this.handleValidationResult.bind(this);
        this.submitResetPasswordData = this.submitResetPasswordData.bind(this);
        this.getFormHeaderLabel = this.getFormHeaderLabel.bind(this);
        this.handleSignInSuccessful = this.handleSignInSuccessful.bind(this);
        this.resetForm = this.resetForm.bind(this);

        this.loadResetPasswordForm();
    }

    loadResetPasswordForm() {
        const { actions, resetPasswordFormData } = this.props;

        if (isEmpty(resetPasswordFormData)) {
            actions.loadSSOResetPasswordFormData();
        }
    }

    componentWillReceiveProps(nextProps) {
        const {
            isResetPasswordSuccessful,
            isSignInSuccessful,
            loading
        } = nextProps;

        if (isSignInSuccessful) {
            this.setState(formStateHelpers.updateProcessingState(false), this.handleSignInSuccessful);
            return;
        }

        if (!loading && isResetPasswordSuccessful) {
            this.setState(formStateHelpers.updateProcessingState(false), this.signInUser);
            return;
        }

        if (!loading && !isResetPasswordSuccessful) {
            this.setState(formStateHelpers.updateProcessingState(false));
        }
    }

    componentWillUnmount() {
        this.resetForm();
    }

    resetForm() {
        const { actions } = this.props;
        this.setState(initialState.resetPasswordFormState);
        actions.resetResetPasswordFormState();
    }

    componentDidMount() {
        const verificationCode = getParameterByName(formConstants.verificationCode);
        this.setState(formStateHelpers.updateVerificationCode(verificationCode));
    }

    handleSubmit(event) {
        event.preventDefault();
        const { resetPasswordFormData } = this.props;
        this.setState(formStateHelpers.handleFormValidation(resetPasswordFormData), this.handleValidationResult);
    }

    handleValidationResult() {
        if (!this.state.formHasErrors) {
            this.setState(formStateHelpers.updateProcessingState(true), this.submitResetPasswordData);
        }
    }

    submitResetPasswordData() {
        const { actions, resetPasswordFormData } = this.props;
        const { callBackUrl } = resetPasswordFormData;
        actions.handleResetPassword(this.state, callBackUrl);
    }

    signInUser() {
        const { actions } = this.props;
        const userSignInData = {
            [formConstants.emailAddress]: this.state[formConstants.emailAddress],
            [formConstants.password]: this.state[formConstants.password]
        };

        actions.signInUser(userSignInData);
    }

    handleSignInSuccessful() {
        reloadToBasePage();
    }

    getFormHeaderLabel() {
        const { resetPasswordFormData } = this.props;

        if (isEmpty(resetPasswordFormData)) {
            return formMessageConstants.resetPasswordFormHeaderLabel;
        }

        return resetPasswordFormData.formText;
    }

    displayForm() {
        const {
            isResetPasswordSuccessful,
            resetPasswordMessages,
            resetPasswordFormData
        } = this.props;

        if (isEmpty(resetPasswordFormData)) {
            return null;
        }

        return (<form onSubmit={this.handleSubmit}>
            <FormMessage
                isSuccessMessage={isResetPasswordSuccessful}
                messages={resetPasswordMessages}></FormMessage>
            {this.displayResetPasswordForm()}
            <SSOFormFooter
                onSubmit={this.handleSubmit}
                footerButtonText={formMessageConstants.reset}
            ></SSOFormFooter >
        </form>);
    }

    displayResetPasswordForm() {
        const { resetPasswordFormData } = this.props;
        const { verificationCode } = this.state;

        return FormBuilder({
            formData: resetPasswordFormData,
            verificationCode,
            handleChange: (event) => { this.setState(formStateHelpers.handleFieldChange(event.target)); },
            handleFieldChange: (event) => { this.setState(formStateHelpers.handleFieldChangeWithValidation(event.target)); },
            handleConfirmPasswordChange: (event) => { this.setState(formStateHelpers.handleConfirmPasswordFieldChange(event.target)); },
            handleFieldValidState: (fieldName) => { const { errors } = this.state; return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors); },
        });
    }

    render() {
        const { isProcessing } = this.state;
        const { loading } = this.props;

        return (
            <div className='modal__content form-container'>
                <div className='auto-ph-md auto-p-md constrain-tablet ff-founders fs-14'>
                    <br />
                    {(isProcessing || loading) ? <FormSpinner>/</FormSpinner> : null}
                    {this.displayForm()}
                </div>
            </div>
        );
    }
}

ResetPasswordForm.propTypes = {
    loading: PropTypes.bool.isRequired,
    resetPasswordFormData: PropTypes.object
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        resetPasswordFormData: state.resetPasswordForm.resetPasswordFormData,
        isResetPasswordSuccessful: state.resetPasswordForm.isResetPasswordSuccessful,
        resetPasswordMessages: state.resetPasswordForm.resetPasswordMessages,
        isSignInSuccessful: state.signInForm.isSignInSuccessful,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            loadSSOResetPasswordFormData: bindActionCreators(resetPasswordFormActions.loadSSOResetPasswordFormData, dispatch),
            handleResetPassword: bindActionCreators(resetPasswordFormActions.handleResetPassword, dispatch),
            resetResetPasswordFormState: bindActionCreators(resetPasswordFormActions.resetResetPasswordFormState, dispatch),
            signInUser: bindActionCreators(signInFormActions.signInUser, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ResetPasswordForm);
